import styled from 'styled-components';

export const WrapperLoyiha = styled.div`
  display: flex;
  flex-direction: column;
`;
export const AddBtn = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const LoyihaMap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;
`;
